"use strict";

define('components/filter_bar/table/bulk_investor_report',['components/ajax'], function(ajax) {
    var bulkInvestorReportComponent = {
        initWithContext: function(context) {
            var tableObjectType = context.tableFilterBarData.tableObjectType;

            // Only for contacts and accounts
            if (tableObjectType != 3 && tableObjectType != 6) return;

            // Click handler for creating investor reports in bulk
            var reportButton = context.buttonbarNode.find('.selection-investor-report button:not(.disabled)');
            reportButton.click(function() {
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                var objectName = tableObjectType == 3 ? 'contact' : 'account';
                var publicationType = objectName + '_investor_report';

                var formData = new FormData();
                formData.append('object_ids', JSON.stringify(objectIds));
                formData.append('publication_type', publicationType);

                ajax('/publication/create_bulk/' + publicationType, {
                    formData: formData
                });
            });
        }
    };

    return bulkInvestorReportComponent;
});
